import tinycolor from 'tinycolor2'

import * as styles from './ColorLayer.module.css'

function ColorLayer({ children, color }) {
  if (!color) {
    return children
  }

  const bgColor = tinycolor(color).setAlpha(0.5).toRgbString()

  return (
    <div className={styles.colorLayer} style={{ '--bg-color': bgColor }}>
      {children}
    </div>
  )
}

export default ColorLayer
